import { render } from "./QualificationMatrix.vue?vue&type=template&id=23681b08&scoped=true"
import script from "./QualificationMatrix.vue?vue&type=script&lang=js"
export * from "./QualificationMatrix.vue?vue&type=script&lang=js"

import "./QualificationMatrix.vue?vue&type=style&index=0&id=23681b08&scoped=true&lang=scss"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23681b08"]])

export default __exports__